import { render, staticRenderFns } from "./sustainable-development.vue?vue&type=template&id=cb4abb7e&scoped=true&name=sustainable-development&"
import script from "./sustainable-development.vue?vue&type=script&lang=js&"
export * from "./sustainable-development.vue?vue&type=script&lang=js&"
import style0 from "./sustainable-development.vue?vue&type=style&index=0&id=cb4abb7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4abb7e",
  null
  
)

/* custom blocks */
import block0 from "./sustainable-development.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports